import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { fetchUserPushEventEnabled, upsertUserPushEventEnabled } from '../services/pushEventPreferencesService'

export function usePushEventPreference(eventType: string) {
  const { user } = useAuth()
  const userId = user?.id || null
  const safeEventType = String(eventType || '').trim()

  const [enabled, setEnabled] = React.useState<boolean | null>(null)
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const load = React.useCallback(async () => {
    if (!userId || !safeEventType) {
      setEnabled(null)
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)
    try {
      const value = await fetchUserPushEventEnabled(userId, safeEventType)
      setEnabled(value)
    } catch (e: any) {
      setError(e?.message ?? 'Falha ao carregar preferencia de notificacao')
      setEnabled(true)
    } finally {
      setLoading(false)
    }
  }, [safeEventType, userId])

  React.useEffect(() => {
    load()
  }, [load])

  async function save(next: boolean): Promise<boolean> {
    if (!userId || !safeEventType) return false
    setSaving(true)
    setError(null)
    try {
      const updated = await upsertUserPushEventEnabled(userId, safeEventType, next)
      setEnabled(updated)
      return true
    } catch (e: any) {
      setError(e?.message ?? 'Falha ao salvar preferencia de notificacao')
      return false
    } finally {
      setSaving(false)
    }
  }

  return {
    enabled,
    loading,
    saving,
    error,
    reload: load,
    save,
    setEnabled,
  }
}

